import { render, staticRenderFns } from "./tanda_terima_SPPT_STP.vue?vue&type=template&id=3c0ace11&"
import script from "./tanda_terima_SPPT_STP.vue?vue&type=script&lang=js&"
export * from "./tanda_terima_SPPT_STP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports